import React from 'react';

interface IssuuEmbedProps {
  src: string;
  height?: string;
  width?: string;
}

export const IssuuEmbed: React.FC<IssuuEmbedProps> = ({
  src,
  height = '1000px',
  width = '100%'
}) => {
  return (
    <iframe
      src={src}
      style={{ border: 'none' }}
      width={width}
      height={height}
      allow="clipboard-write"
      sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
      allowFullScreen
      title="Issuu Publication"
    />
  );
};

export default IssuuEmbed;
